(() => {
  document.querySelectorAll('[data-sr-project-intent]').forEach(link => {
    link.addEventListener('click', () => {
      const select = document.querySelector('sr-personal-help [data-intent]');
      if (!select) return;
      select.value = link.dataset.srProjectIntent;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();